import { siteDevelopmentUrl } from "../../utility/Index";

export const refundData = {
  Refund: {
    Title: "Refund Process",
    GeneralTopData: [
      "At eSquadifi, we want to ensure you understand how refunds work for ticketed events and other platform-related purchases. Below is an overview of our refund process:",
    ],
    GeneralBottomData: [
      "For further inquiries, please reach out to our Help Desk for support.",
    ],
    Steps: [
      {
        StepTitle: "Eligibility for Refunds",
        Description: [
          "Ticketed Events: If a ticketed event is canceled or doesn’t meet the required audience threshold, you will automatically receive a refund.",
          "Switch to Free Event: If an exclusive event switches to a free kall-out event due to low ticket sales, all purchased tickets will be refunded.",
        ],
      },
      {
        StepTitle: "Requesting a Refund",
        Description: [
          `How to Request: Refunds are processed automatically, but if you need assistance, go to the Help Centre and submit a <a href='${siteDevelopmentUrl}/Profile'>refund request.</a>`,
        ],
      },
      {
        StepTitle: "Non-Refundable Purchases",
        Description: [
          "Gifts, Tokens, and Belts: Purchases of tokens, gifts, and belts are non-refundable once purchased.",
        ],
      },
      {
        StepTitle: "Processing Time",
        Description: [
          "Refunds may take 5-10 business days depending on your payment method.",
        ],
      },
    ],
  },
};
